import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Logger, GlobalInfoService } from '@app/core';
import { Observable } from 'rxjs/Observable';
import { ToastrService } from 'ngx-toastr';

const log = new Logger('BasicProcessConfigurationGuard');

@Injectable()
export class BasicProcessConfigurationGuard implements CanDeactivate<any> {
  private pendingChanges: boolean;
  private tramiteIsSynchronized: boolean;

  constructor(private gis: GlobalInfoService, private toastr: ToastrService) {
    this.gis.get().subscribe(global => {
      this.pendingChanges = global.pendingChanges.processAutomation;
      this.tramiteIsSynchronized = global.tramiteIsSynchronized;
    });
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.pendingChanges) {
      this.toastr.warning(`Hay cambios en el flujo que no estan sincronizados con la DB,
      por favor realiza la sincronización antes de irte.`, 'No olvides sincronizar');
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/basic-process-configuration/shared/basic-process-configuration.guard.ts